export const percent = {
  pr0: 0,
  pr25: 25,
  pr50: 50,
  pr75: 75,
  pr85: 85,
  pr95: 95,
  pr100: 100,
};
